import React from 'react';

import { FeatureBlock, IFeature } from './FeatureBlock';

interface IProps {
  handleArrow(event: React.MouseEvent<HTMLImageElement>): void;
  arrowIcon: string;
  features: Array<Array<IFeature>>;
}

export class AmazingFeatures extends React.Component<IProps> {
  render() {
    return (
      <div id="section-grey">
        <div className="container">
          <div className="row margin-bottom-50">
            <div className="col-md-12 text-center">
              <h2 className="section-title">Amazing Features</h2>
              <div className="separator_wrapper">
                <span
                  className="glyphicon glyphicon-star star"
                  aria-hidden="true"
                ></span>
              </div>
            </div>
          </div>
          {this.props.features.map((feature, i) => {
            return <FeatureBlock key={i} feature={feature} />;
          })}
          <div className="toporbottomarrow">
            <img
              onClick={this.props.handleArrow}
              src={this.props.arrowIcon}
              alt="arrow"
            />
          </div>
        </div>
      </div>
    );
  }
}
